import React from 'react';
import { Button, Col, Container, Form, Image, Row, Table } from 'react-bootstrap';
import Select from 'react-select';
import { LoaderComponente } from "../../Components/LoaderComponente";
import { NavBarComponente } from '../../Components/NavBarComponente';
import "../../Estilo/Form.css";
import baixo from '../../Imagens/arrow-down-blue-16.png';
import voltar from '../../Imagens/arrow-left-16.png';
import voltarInicio from '../../Imagens/arrow-left-first-16.png';
import proximo from '../../Imagens/arrow-right-16.png';
import proximoUltimo from '../../Imagens/arrow-right-last-16.png';
import cima from '../../Imagens/arrow-up-blue-16.png';
import clearFilter from '../../Imagens/clear-filter.png';
import fechar from '../../Imagens/close-24.png';
import filtrar from '../../Imagens/filter-16.png';
import printer from '../../Imagens/printer.png';
import { FormEvent } from '../../ScreenGeneric/Models/FormEvent';
import { TypePagination } from '../TableGeneric/TableGenericViewController';
import { AddressRelatoryViewModel } from './AddressRelatoryViewModel';
import { GlobalViewModel } from '../Global/GlobalViewModel';
import { InputModalSelectComponent } from '../../Components/InputModalSelectComponent';


interface MyProps {
    navigation: any
    delegate: AddressRelatory
    viewModel: AddressRelatoryViewModel
}

export interface AddressRelatory {
    tapDimiss(navigation: any): void
}
export interface Filters {
    logradouro: string,
    numero: string,
    sgepbairros: string,
    ccidade: string,
    zona: string,
    sgepdistrito: string,
    sgepzoneamento: string,
    pagina: number
}

export class AddressRelatoryViewController extends React.Component<MyProps> {

    private globalViewModel = new GlobalViewModel()
    private formEvent: FormEvent
    state = {
        isLoading: true,
        json: {},
        data: Array<any>(),
        total: 0,
        neighborhoodList: Array<any>(),
        zoningList: Array<any>(),
        districtList: Array<any>(),
        clearValue: false,
        showFilter: false,
        filters: ({
            logradouro: '',
            numero: '',
            sgepbairros: '',
            ccidade: '',
            zona: '',
            sgepdistrito: '',
            sgepzoneamento: '',
            pagina: 1
        }),
        countPage: 1
    }

    constructor(props: any) {
        super(props)
        this.formEvent = new FormEvent(this)
    }

    componentDidMount() {
        this.lists()
        this.screenUpdate()
    }

    render() {
        return (
            <div>
                <NavBarComponente propNav={this.props.navigation} />
                <div>
                    <Container fluid={true}>
                        <Row>
                            <Col>
                                <div className="title">
                                    <h3>Relatório Endereços</h3>
                                </div>
                                <div className="buttonClose">
                                    <Image className="imageClose"
                                        onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)}
                                        src={fechar} />
                                </div>
                            </Col>
                        </Row>
                        <Form className="containerForm">
                            <>
                                <Row className="header">
                                    <Col xs="12" className="infoFilter">
                                        <h3 onClick={() => this.setState({ showFilter: !this.state.showFilter })}>
                                            <Image
                                                className="iconFilter"
                                                src={this.state.showFilter ? cima : baixo} />
                                            EXIBIR FILTROS
                                        </h3>
                                    </Col>
                                    {this.state.showFilter &&
                                        <Col xs="12" className="containerFilter">
                                            <Row>
                                                <Col lg="2" xs="12" className="bottom10">
                                                    <Form.Label>Logradouro</Form.Label>
                                                    <Form.Control
                                                        id="logradouro"
                                                        type="text"
                                                        value={this.state.filters.logradouro}
                                                        onChange={(e: any) => this.verifyFilters('logradouro', e.target.value)}
                                                        placeholder="Digite..." />
                                                </Col>
                                                <Col lg="2" xs="12" className="bottom10">
                                                    <Form.Label>Número</Form.Label>
                                                    <Form.Control
                                                        id="numero"
                                                        type="text"
                                                        value={this.state.filters.numero}
                                                        onChange={(e: any) => this.verifyFilters('numero', e.target.value)}
                                                        placeholder="Digite..." />
                                                </Col>

                                                <Col lg="2" xs="12" className="bottom10">
                                                    <Form.Label>Bairro</Form.Label>
                                                    <Select
                                                        id="sgepbairros"
                                                        value={this.state.filters.sgepbairros ? this.formEvent.onValueSelect('select', 'camada', this.state.neighborhoodList) : null}
                                                        onChange={(e: any) => this.verifyFilters('sgepbairros', e ? e.value : null)}
                                                        closeMenuOnSelect={true}
                                                        placeholder={"Selecione"}
                                                        options={this.state.neighborhoodList}
                                                        isClearable
                                                    />
                                                </Col>
                                                <Col lg="4" xs="12" className="bottom10">
                                                    <InputModalSelectComponent
                                                        id="Sequencial"
                                                        keyValue="nome"
                                                        label="Cidade"
                                                        required={true}
                                                        placeholder="Procure"
                                                        showAddButton={false}
                                                        navigation={this.props.navigation}
                                                        titleModal="Cidades"
                                                        table="cidade"
                                                        valueDefault={this.state.filters.ccidade}
                                                        getValue={(id: number, value: string) => this.verifyFilters('ccidade', String(id))}
                                                        clearValue={this.state.clearValue}
                                                        setClearValue={() => this.setState({ clearValue: false })}
                                                    />
                                                </Col>

                                                <Col lg="2" xs="12" className="bottom10">
                                                    <Form.Label>Distrito</Form.Label>
                                                    <Select
                                                        id="sgepdistrito"
                                                        value={this.state.filters.sgepdistrito ? this.formEvent.onValueSelect('select', 'camada', this.state.districtList) : null}
                                                        onChange={(e: any) => this.verifyFilters('sgepdistrito', e ? e.value : null)}
                                                        closeMenuOnSelect={true}
                                                        placeholder={"Selecione"}
                                                        options={this.state.districtList}
                                                        isClearable
                                                    />
                                                </Col>
                                                <Col lg="2" xs="12" className="bottom10">
                                                    <Form.Label>Zoneamento</Form.Label>
                                                    <Select
                                                        id="sgepzoneamento"
                                                        value={this.state.filters.sgepzoneamento ? this.formEvent.onValueSelect('select', 'camada', this.state.zoningList) : null}
                                                        onChange={(e: any) => this.verifyFilters('sgepzoneamento', e ? e.value : null)}
                                                        closeMenuOnSelect={true}
                                                        placeholder={"Selecione"}
                                                        options={this.state.zoningList}
                                                        isClearable
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs='12'>
                                                    <Button
                                                        onClick={() => this.screenUpdate()}
                                                        variant="info"
                                                        type="button"
                                                        className="btnFilter right10">
                                                        <Image
                                                            className="iconBtnFilter"
                                                            src={filtrar} />
                                                        Filtrar
                                                    </Button>
                                                    <Button
                                                        onClick={() => {
                                                            this.clearFilters()
                                                            this.setState({
                                                                clearValue: true
                                                            })
                                                        }}
                                                        variant="info"
                                                        type="button"
                                                        className="btnFilter"
                                                    >
                                                        <Image className="iconBtnFilter" src={clearFilter} />
                                                        Limpar
                                                    </Button>

                                                </Col>
                                            </Row>
                                        </Col>}

                                    <Col xs="12" style={{ marginTop: 20 }}>
                                        <Button variant="danger" type="button" className="buttonGeneric colorRed" onClick={() => this.printRelatory(this.state.filters)}>
                                            <Image className="iconButtonGeneric" src={printer} />
                                            PDF
                                        </Button>
                                    </Col>
                                </Row>
                            </>

                            <Table responsive hover style={{ textAlign: 'left', fontSize: 14, backgroundColor: "#ffffff" }}>

                                <thead style={{ backgroundColor: "#eeeeee" }}>
                                    <tr>
                                        <th>Sequencial</th>
                                        <th>Logradouro</th>
                                        <th>Numero</th>
                                        <th>Bairro</th>
                                        <th>Cidade</th>
                                        <th>Zona</th>
                                        <th>Distrito</th>
                                        <th>Zoneamento</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {this.state.data && this.state.data.map((item, key) => (
                                        <tr key={key}>
                                            <td>{key + 1}</td>
                                            <td>{item.logradouro}</td>
                                            <td>{item.numero}</td>
                                            <td>{item.bairro}</td>
                                            <td>{item.municipio}</td>
                                            <td>{item.zona}</td>
                                            <td>{item.distrito}</td>
                                            <td>{item.zoneamento}</td>
                                        </tr>
                                    ))}
                                </tbody>

                            </Table>
                            <div style={{ borderWidth: 1, borderStyle: "solid", borderColor: "#cccccc", backgroundColor: "#eeeeee" }}>
                                <Container fluid={true}>
                                    <Row>
                                        <Col xs="12">
                                            <div style={{ height: 30 }}>
                                                <div style={{ float: "right" }}>
                                                    <label style={{ marginLeft: 10, fontSize: 12, fontWeight: "bold" }}>Número de Registros: {this.state.total}</label>
                                                </div>
                                                {this.state.data.length ? (
                                                    <div style={{ float: "left" }}>
                                                        {this.state.filters.pagina != 1 && (
                                                            <>
                                                                <Image
                                                                    style={{ marginLeft: 0, cursor: "pointer" }}
                                                                    src={voltarInicio}
                                                                    onClick={() => this.pagination('first')}
                                                                    width={16}
                                                                    className="center"
                                                                    fluid />
                                                                <Image
                                                                    style={{ marginLeft: 10, cursor: "pointer" }}
                                                                    src={voltar}
                                                                    onClick={() => this.pagination('back')}
                                                                    width={16}
                                                                    className="center"
                                                                    fluid />
                                                            </>
                                                        )}
                                                        <label className="tablePage">{this.state.filters.pagina}/{this.state.countPage}</label>
                                                        {this.state.filters.pagina !== this.state.countPage && (
                                                            <>
                                                                <Image
                                                                    style={{ marginLeft: 10, cursor: "pointer" }}
                                                                    src={proximo}
                                                                    onClick={() => this.pagination('next')}
                                                                    width={16}
                                                                    className="center"
                                                                    fluid />
                                                                <Image
                                                                    style={{ marginLeft: 10, cursor: "pointer" }}
                                                                    src={proximoUltimo}
                                                                    onClick={() => this.pagination('last')}
                                                                    width={16}
                                                                    className="center"
                                                                    fluid />
                                                            </>
                                                        )}
                                                    </div>
                                                ) : <label className="tablePage">0/{this.state.countPage}</label>}
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>


                        </Form>
                    </Container>
                </div>
                <LoaderComponente show={this.state.isLoading} hide={() => this.setState({ isLoading: this.state.isLoading })} />
            </div>
        )
    }
    private printRelatory(filters: any) {
        this.setState({
            isLoading: true
        })
        this.props.viewModel.fetchAddressRelatory(filters).then((data) => {
            this.setState({
                isLoading: false
            })
        })
    }
    private screenUpdate() {
        this.setState({ isLoading: true })
        this.props.viewModel.fetchAddress(this.state.filters).then((response: any) => {
            if (response.length) {
                this.setState({
                    isLoading: false,
                    data: response,
                    countPage: Math.ceil(response[0].total / 10),
                    total: Number(response[0].total)
                })
            } else {
                this.setState({
                    isLoading: false,
                    data: response,
                    countPage: 0,
                    total: 0
                })
            }
        })
    }

    private lists() {
        this.globalViewModel.fetchDataToSelectInput('gepbairros', 'sgepbairros').then((response: any) => {
            if (response.length) {
                this.setState({
                    neighborhoodList: response
                })
            }
        })

        this.globalViewModel.fetchDataToSelectInput('gepdistrito', 'sgepdistrito').then((response: any) => {
            if (response.length) {
                this.setState({
                    districtList: response
                })
            }
        })
        this.globalViewModel.fetchDataToSelectInput('gepzoneamento', 'sgepzoneamento').then((response: any) => {
            if (response.length) {
                this.setState({
                    zoningList: response
                })
            }
        })
    }

    private verifyFilters(key: keyof Filters, newValue: string) {
        let newFilters = this.state.filters as any;
        newFilters[key] = newValue;
        if (key !== 'pagina') newFilters['pagina'] = 1;
        this.setState({
            filters: newFilters
        });
    }

    private async pagination(type: TypePagination) {
        var page
        switch (type) {
            case 'first':
                page = 1
                break;
            case 'back':
                page = this.state.filters.pagina - 1
                break;
            case 'next':
                page = this.state.filters.pagina + 1
                break;
            case 'last':
                page = this.state.countPage
                break;
        }
        await this.setState({
            filters: {
                ...this.state.filters,
                pagina: page
            }
        })
        this.screenUpdate()
    }

    private async clearFilters() {
        await this.setState({
            filters: {
                logradouro: '',
                numero: '',
                sgepbairros: '',
                ccidade: '',
                zona: '',
                sgepdistrito: '',
                sgepzoneamento: '',
                pagina: 1
            }
        });
        this.screenUpdate();
    }
}